import React from 'react';
import styled from 'styled-components';
import { pitchTheme } from '../styles/theme';

const Placeholder = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  font-family: ${pitchTheme.fontUi};
  font-size: clamp(0.75rem, 2.5vw, 0.9375rem);
  font-weight: 700;
  letter-spacing: 0.14em;
  color: ${pitchTheme.textMuted};
  user-select: none;
`;

const LogoImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: left center;
`;

interface SlideLogoProps {
  logoUrl?: string | null;
  alt?: string;
}

/** Deck logo slot on slides — placeholder text or uploaded image. */
const SlideLogo: React.FC<SlideLogoProps> = ({ logoUrl, alt = 'Company logo' }) => {
  if (logoUrl) {
    return <LogoImage src={logoUrl} alt={alt} />;
  }

  return <Placeholder aria-hidden>LOGO</Placeholder>;
};

export default SlideLogo;
